import React from "react";
import BankBlocks from "../components/BankBlocks";



const BanksPage: React.FC = () => {

  return (
    <div className="App">
      <div className="white-back">
        <BankBlocks/>
      </div>
    </div>
  );
};

export default BanksPage;
